import { render, staticRenderFns } from "./AnimalWeightRecord.ManualPanel.vue?vue&type=template&id=2407d482&scoped=true&"
import script from "./AnimalWeightRecord.ManualPanel.vue?vue&type=script&lang=js&"
export * from "./AnimalWeightRecord.ManualPanel.vue?vue&type=script&lang=js&"
import style0 from "./AnimalWeightRecord.ManualPanel.vue?vue&type=style&index=0&id=2407d482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2407d482",
  null
  
)

export default component.exports